import React from 'react';

// Define the available yacht types
const yachtTypes = ['Motor Yacht', 'Sailing Yacht', 'Catamaran', 'Cruiser', 'Rib Boat', 'Caique'];

const YachtTypeSelector = ({ selectedTypes, onTypeChange }) => {
  const handleTypeClick = (type) => {
    const newSelectedTypes = selectedTypes.includes(type)
      ? selectedTypes.filter((t) => t !== type) // Deselect if already selected
      : [...selectedTypes, type]; // Select if not already selected
    onTypeChange(newSelectedTypes);
  };

  return (
    <div className="mb-6 bg-white p-4 rounded-lg shadow">
      <h3 className="font-semibold text-lg mb-3 text-blue-900 JosefinSans">Select Yacht Type</h3>
      <div className="flex flex-wrap gap-2">
        {yachtTypes.map((type) => (
          <button
            key={type}
            onClick={() => handleTypeClick(type)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 ease-in-out JosefinSans 
              ${selectedTypes.includes(type)
                ? 'bg-blue-600 text-white shadow-md' // Selected state
                : 'bg-gray-100 text-gray-700 hover:bg-blue-100 hover:text-blue-700' // Default state
              }
            `}
          >
            {type}
          </button>
        ))}
      </div>
    </div>
  );
};

export default YachtTypeSelector;
